import React, { useEffect, useState } from "react";
import "./Clientes.css";
import "../styles/theme-dark.css";
import axios from "../api/axios";
import { useNavigate } from "react-router-dom";

export default function Bancos() {
  const navigate = useNavigate();

  const [lista, setLista] = useState([]);

  // FILTROS
  const [fDesde, setFDesde] = useState("");
  const [fHasta, setFHasta] = useState("");
  const [fTexto, setFTexto] = useState("");

  // MODAL
  const [modal, setModal] = useState(null);
  const [listaCompras, setListaCompras] = useState([]);

  // =====================================================
  // CARGAR SALIDAS
  // =====================================================
  const cargar = async () => {
    try {
      const r = await axios.get("/bancos");
      setLista(r.data);
    } catch (err) {
      console.error("Error cargando movimientos", err);
    }
  };

  // CARGAR COMPRAS PARA VINCULAR
  const cargarCompras = async () => {
    const r = await axios.get("/compras");
    setListaCompras(r.data);
  };

  useEffect(() => {
    cargar();
  }, []);

  // =====================================================
  // FILTRADA
  // =====================================================
  const filtrada = lista.filter((m) => {
    const fechaMov = new Date(m.fecha);

    if (fDesde && fechaMov < new Date(fDesde)) return false;
    if (fHasta && fechaMov > new Date(fHasta)) return false;
    if (fTexto && !m.descripcion.toLowerCase().includes(fTexto.toLowerCase()))
      return false;

    return true;
  });

  // =====================================================
  // PASAR A COMPRAS
  // =====================================================
  const pasarACompras = async (mov) => {
    setModal(mov);
    cargarCompras();
  };

  return (
    <div className="page-dark">
      {/* HEADER */}
      <header
        style={{
          padding: "20px 30px",
          marginBottom: 25,
          background: "rgba(15,23,42,0.65)",
          borderBottom: "1px solid rgba(255,255,255,0.12)",
          backdropFilter: "blur(10px)",
          borderRadius: "0 0 16px 16px",
          boxShadow: "0 10px 25px rgba(0,0,0,0.45)",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <img src="/corex-logo.png" alt="COREX" style={{ height: 40 }} />
            <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700 }}>
              Movimientos bancarios
            </h1>
          </div>

          <button className="glass-btn" onClick={() => window.history.back()}>
            ← Volver
          </button>
        </div>

        <p style={{ opacity: 0.7, marginTop: 6 }}>
          Solo salidas de dinero. Clasifica tus gastos hacia Compras.
        </p>
      </header>

      {/* FILTROS */}
      <div className="glass-box" style={{ marginBottom: 20 }}>
        <h3 style={{ marginBottom: 10, opacity: 0.8 }}>Filtros</h3>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, minmax(180px, 1fr))",
            gap: 12,
          }}
        >
          <input
            type="date"
            className="glass-input"
            value={fDesde}
            onChange={(e) => setFDesde(e.target.value)}
          />

          <input
            type="date"
            className="glass-input"
            value={fHasta}
            onChange={(e) => setFHasta(e.target.value)}
          />

          <input
            className="glass-input"
            placeholder="Buscar texto (concepto…)"
            value={fTexto}
            onChange={(e) => setFTexto(e.target.value)}
          />
        </div>
      </div>

      {/* TABLA */}
      <div className="glass-box">
        <table className="glass-table">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Descripción</th>
              <th>Cuenta/Tarjeta</th>
              <th>Importe</th>
              <th style={{ textAlign: "right" }}>Estado</th>
              <th style={{ textAlign: "right" }}>Acciones</th>
            </tr>
          </thead>

          <tbody>
            {filtrada.map((m) => (
              <tr key={m.id}>
                <td>{m.fecha?.substring(0, 10)}</td>
                <td>{m.descripcion}</td>
                <td>{m.metodo}</td>
                <td>{Number(m.importe).toFixed(2)} €</td>

                <td style={{ textAlign: "right" }}>
                  {m.compraId ? (
                    <span style={{ color: "#22c55e" }}>Contabilizado</span>
                  ) : (
                    <span style={{ opacity: 0.6 }}>Pendiente</span>
                  )}
                </td>

                <td style={{ textAlign: "right" }}>
                  {!m.compraId && (
                    <button
                      className="glass-btn"
                      style={{ fontSize: 12 }}
                      onClick={() => pasarACompras(m)}
                    >
                      Pasar a compras
                    </button>
                  )}

                  {m.compraId && (
                    <button
                      className="glass-btn"
                      style={{ fontSize: 12 }}
                      onClick={() => navigate(`/compras/${m.compraId}`)}
                    >
                      Ver compra
                    </button>
                  )}
                </td>
              </tr>
            ))}

            {filtrada.length === 0 && (
              <tr>
                <td
                  colSpan="6"
                  style={{ textAlign: "center", opacity: 0.5, padding: 15 }}
                >
                  No hay movimientos…
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ============================
          MODAL
      ============================ */}
      {modal && (
        <div className="modal-bg">
          <div className="modal">
            <h2>Clasificar movimiento</h2>

            <p style={{ opacity: 0.8 }}>
              {modal.descripcion} — {modal.importe.toFixed(2)} €
            </p>

            <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
              {/* NUEVA COMPRA */}
              <button
                className="glass-btn"
                onClick={async () => {
                  await axios.post("/bancos/nueva-compra", {
                    movimientoId: modal.id,
                  });
                  setModal(null);
                  alert("Compra creada");
                  cargar();
                }}
              >
                Crear nueva compra
              </button>

              {/* VINCULAR EXISTENTE */}
              <button
                className="glass-btn"
                onClick={() => {
                  document.getElementById("compras-list").style.display =
                    "block";
                }}
              >
                Vincular existente
              </button>

              {/* CANCELAR */}
              <button
                className="glass-btn"
                style={{ background: "rgba(255,0,0,0.3)" }}
                onClick={() => setModal(null)}
              >
                Cancelar
              </button>
            </div>

            {/* LISTA DE COMPRAS */}
            <div
              id="compras-list"
              style={{
                display: "none",
                marginTop: 20,
                maxHeight: 200,
                overflow: "auto",
              }}
            >
              <h3>Elige compra existente</h3>

              {listaCompras.map((c) => (
                <div
                  key={c.id}
                  className="glass-box"
                  style={{
                    padding: 10,
                    marginBottom: 8,
                    cursor: "pointer",
                  }}
                  onClick={async () => {
                    await axios.post("/bancos/vincular", {
                      movimientoId: modal.id,
                      compraId: c.id,
                    });
                    setModal(null);
                    alert("Movimiento vinculado");
                    cargar();
                  }}
                >
                  #{c.id} — {c.proveedorNombre} — {c.total} €
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
